"use client"

import { Component } from "react"
import PageHeader from "../../../components/common/PageHeader"
import SectionTitle from "../../../components/common/SectionTitle"

class HakumI extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    const teamMembers = [
      { role: "대표이사", name: "염종석 목사", church: "성실교회" },
      { role: "소장", name: "박정훈 목사", church: "양문교회" },
      { role: "부소장", name: "박봉선 목사", church: "한길교회" },
      { role: "부장", name: "김진영 목사", church: "성실교회" },
      { role: "부장", name: "신강자 간사", church: "" },
      { role: "총무부장", name: "손모아 전도사", church: "" },
    ]

    const staff = [
      { category: "그림 작가", members: "손모아 전도사, 김정은 집사, 박예은 청년, 조은비 청년" },
      { category: "나레이션", members: "권상례 사모, 백현진 집사" },
      { category: "어린이팀", members: "김서현 사모 외 어린이 8명" },
    ]

    const timeline = [
      { date: "2020.04", event: "영상선교회 설립" },
      { date: "2020.05", event: "첫 설교 영상 '디모데의 신앙' 제작" },
      { date: "2020.07", event: "설립예배 및 선교회 이름 공모" },
      { date: "2021.01", event: "하꿈아이 영상선교회 유튜브 채널 개설" },
      { date: "2021.10", event: "하꿈아이 실버팀 출범, 하꿈아이 어린이팀 개설" },
      { date: "2023.06", event: "하꿈아이 글로벌화 – 영어 번역본 제작" },
      { date: "2024.05", event: "하꿈아이 동남아 지부 설립 – 베이스 캠프 : 베트남 호치민" },
    ]

    const links = [
      {
        title: "하꿈아이 유튜브",
        url: "https://www.youtube.com/@hakumi0191/",
        icon: "🎥",
      },
      {
        title: "하꿈아이 자료 다운로드",
        url: "https://drive.google.com/drive/folders/1F_qehHrWJk7UFr-c1t4Brn9EW9KiWYI6?usp=drive_link",
        icon: "📁",
      },
      {
        title: "하꿈아이 블로그",
        url: "https://blog.naver.com/hakumi0191",
        icon: "📝",
      },
      {
        title: "하꿈아이 베트남 지부 유튜브",
        url: "https://www.youtube.com/@Hakum-Imediamissionary-p1c/videos",
        icon: "🌏",
      },
    ]

    return (
        <section className="pf-page hakum-i">

          <div className="hakum-container">
            {/* 메인 소개 섹션 */}
            <div className="hakum-intro">
              <div className="hakum-logo">
                <h1 className="hakum-title">하꿈아이</h1>
                <div className="hakum-subtitle">
                  <p>▶ 하나님의 꿈을 꾸는 나</p>
                  <p>▶ 하나님의 꿈을 이루는 다음세대</p>
                </div>
              </div>

              <div className="hakum-description">
                <p>
                  <strong>[하꿈아이 영상선교회]</strong>는 '하나님의 꿈을 꾸는 나' 그리고 '하나님의 꿈을 꾸는 아이'란 뜻을
                  가진 이름으로, 다음세대를 살리기 위한 영상 선교회입니다.
                </p>
                <p>
                  합신 교단의 건전한 신학을 바탕으로 성실교회에서 시작된 하꿈아이는, 주일학교를 운영하기 힘든 농어촌의
                  교회들, 혹은 미자립 교회들, 선교지의 어린 영혼들을 살리고자 시작되었습니다.
                </p>
                <p>
                  하꿈아이는 설교를 애니메이션 영상으로 제작하여 매 주 한편씩 유튜브에 업로드 하고 있습니다. 많은 교회와
                  가정에서 어린 영혼들이 하꿈아이의 영상으로 바른 믿음을 키워 나가고 있습니다.
                </p>
                <div className="hakum-highlight">
                  <p>
                    하꿈아이의 모든 자료는 <strong>'거저 받았으니 거저 주라'</strong>는 말씀을 따라 모두{" "}
                    <strong>무료로 배포</strong>하고 있습니다.
                  </p>
                </div>
              </div>
            </div>

            {/* 글로벌 현황 */}
            <div className="hakum-global">
              <SectionTitle title="글로벌 현황" />
              <p>
                현재 하꿈아이는 한국 뿐 아니라{" "}
                <strong>미국, 캐나다, 일본, 터키, 호주, 인도네시아, 필리핀, 대만, 도미니카공화국, 불가리아</strong> 등
                많은 나라에서 다음세대를 바르게 교육하는데 쓰이고 있습니다. 또한, 하꿈아이 동남아 지부가 베트남 호치민에 설립되어 동남아 선교에 앞장서고 있습니다.
              </p>
            </div>

            {/* 시작과 꿈 */}
            <div className="hakum-vision">
              <SectionTitle title="하꿈아이의 시작과 꿈" />
              <div className="vision-content">
                <p>
                  하꿈아이는 약30년 전 염종석 목사의 꿈에서 시작되었습니다. 분명 영상의 시대가 올 것이고 다음 세대를
                  위해 영상 설교를 준비해야 한다고 생각하고 꿈꾸었던 그 일을 하나님께서 준비하셨고 30년이 지나 시작하게
                  하셨습니다.
                </p>
                <div className="vision-goals">
                  <h4>하꿈아이 영상선교회의 꿈</h4>
                  <ul>
                    <li>하꿈아이 영상선교회의 설교 영상을 통해 하나님의 바른 말씀 안에서 자라나는 다음세대</li>
                    <li>일생의 마지막 순간에 하꿈아이 실버 영상을 통해 하나님을 만나 구원받는 실버세대</li>
                    <li>
                      세계 열방 가운데 바른 말씀을 전하는 도구가 없어 구원받지 못하는 아이들이 없도록 선교에 쓰임받는
                      하꿈아이 영상선교회
                    </li>
                  </ul>
                </div>
                <div className="bible-verse">
                  <p>
                    "너희 말이 내 귀에 들린 대로 내가 너희에게 행하리니"
                  </p>
                  <p>민수기 14장 28절 하반절</p>
                  <p className="amen">아멘.</p>
                </div>
              </div>
            </div>

            {/* 섬기는 사람들 */}
            <div className="hakum-team">
              <SectionTitle title="하꿈아이 영상 선교회" />
              <div className="team-grid">
                <div className="leadership">
                  <h4>리더십</h4>
                  {teamMembers.map((member, index) => (
                      <div key={index} className="team-member">
                        <span className="name">{member.name}</span>
                        {member.church && <span className="church">({member.church})</span>}
                      </div>
                  ))}
                </div>
                <div className="staff">
                  <h4>사역진</h4>
                  {staff.map((group, index) => (
                      <div key={index} className="staff-group">
                        <span className="category">{group.category}</span>
                        <span className="members">{group.members}</span>
                      </div>
                  ))}
                </div>
              </div>
            </div>

            {/* 연혁 */}
            <div className="hakum-timeline">
              <SectionTitle title="하꿈아이 연혁" />
              <div className="timeline">
                <div className="timeline-container">
                  <div className="timeline-line"></div>
                  {timeline.map((item, index) => (
                      <div key={index} className="timeline-item">
                        <div className="timeline-date">{item.date}</div>
                        <div className="timeline-event">{item.event}</div>
                        <div className="timeline-dot"></div>
                      </div>
                  ))}
                </div>
              </div>
            </div>

            {/* 링크 섹션 */}
            <div className="hakum-links">
              <SectionTitle title="하꿈아이 온라인" />
              <div className="links-grid">
                {links.map((link, index) => (
                    <a key={index} href={link.url} target="_blank" rel="noopener noreferrer" className="link-card">
                      <span className="link-icon">{link.icon}</span>
                      <span className="link-title">{link.title}</span>
                    </a>
                ))}
              </div>
            </div>

            {/* 연락처 */}
            <div className="hakum-contact">
              <SectionTitle title="연락처" />
              <div className="contact-info">
                <div className="contact-item">
                  <h4>하꿈아이 사무실</h4>
                  <p>의정부시 입석로 24, 성실교회 1층<br/>하꿈아이 사무실</p>
                  <p>전화: (031) 877-5591</p>
                </div>
                <div className="contact-item">
                  <h4>이메일</h4>
                  <p>hakumi0191@naver.com</p>
                </div>
              </div>
            </div>
          </div>
        </section>
    )
  }
}

export default HakumI
